import React from 'react';

export default function CardLugar({ icon, title }) {
    return (
      <>
        <div class="inline-flex mb-4">
            <span class="w-1/5 flex justify-center items-center bg-primary-800 font-bold rounded-l border-primary-800 border-solid border-2 ">
              <p className='text-[22px] text-primary-50'>{icon}</p>
            </span>
            <span class="w-4/5 text-[14px]  text-primary-800 font-semibold py-2 px-4 rounded-r border-primary-800 border-solid border-y-2 border-r-2">
                      {title}
            </span>
        </div>
      </>
    );
  }